"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CookieConsentNotification = (function () {
    function CookieConsentNotification(cookieConsentNotificationElement, cookieConsentStore, options, onAcceptCallback) {
        var _this = this;
        if (onAcceptCallback === void 0) { onAcceptCallback = null; }
        this.acceptButton = null;
        this.refuseButton = null;
        this.onAcceptClick = function () {
            _this.cookieConsentStore.accept();
            _this.close();
            if (typeof _this.onAcceptCallback === 'function') {
                _this.onAcceptCallback();
            }
        };
        this.onRefuseClick = function () {
            _this.cookieConsentStore.refuse();
            _this.close();
        };
        this.cookieConsentNotificationElement = cookieConsentNotificationElement;
        this.cookieConsentStore = cookieConsentStore;
        this.options = options;
        this.onAcceptCallback = onAcceptCallback;
        this.parentContainer = document.querySelector(this.options.selectors.parentContainer) || document.body;
        this.init();
    }
    CookieConsentNotification.prototype.init = function () {
        var selectors = this.options.selectors;
        if (!this.cookieConsentNotificationElement) {
            return;
        }
        this.acceptButton = document.querySelector(selectors.accept);
        this.refuseButton = document.querySelector(selectors.refuse);
        if (this.acceptButton) {
            this.acceptButton.addEventListener('click', this.onAcceptClick);
        }
        if (this.refuseButton) {
            this.refuseButton.addEventListener('click', this.onRefuseClick);
        }
    };
    CookieConsentNotification.prototype.show = function () {
        var _a = this.options, callbacks = _a.callbacks, activeClass = _a.activeClass;
        this.parentContainer.classList.add(activeClass);
        this.cookieConsentNotificationElement.setAttribute('aria-hidden', 'false');
        if (this.acceptButton) {
            this.acceptButton.focus();
        }
        if (typeof callbacks.onOpenCookieAlert === 'function') {
            callbacks.onOpenCookieAlert(this.cookieConsentNotificationElement);
        }
    };
    CookieConsentNotification.prototype.close = function () {
        var _a = this.options, activeClass = _a.activeClass, callbacks = _a.callbacks;
        this.parentContainer.classList.remove(activeClass);
        this.cookieConsentNotificationElement.setAttribute('aria-hidden', 'true');
        if (typeof callbacks.onCloseCookieAlert === 'function') {
            callbacks.onCloseCookieAlert(this.cookieConsentNotificationElement);
        }
    };
    return CookieConsentNotification;
}());
exports.default = CookieConsentNotification;
